<template>
  <content-area :items="items" />
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
export default {
  components: {
    ContentArea
  },
  computed: {
    info () {
      return this.$store.state.secPolicy
    },
    items () {
      const info = this.info

      if (info) {
        return [
          {
            title: this.$tc('min_length'),
            data: info.min_len,
            testId: 'min_length'
          },
          {
            title: this.$tc('special_char'),
            data: info.min_special,
            testId: 'special_char'
          },
          {
            title: this.$tc('upcase_char'),
            data: info.min_upper,
            testId: 'upcase_char'
          },
          {
            title: this.$tc('lowercase_char'),
            data: info.min_lower,
            testId: 'lowercase_char'
          },
          {
            title: this.$tc('invalid_logins'),
            data: info.max_inv_logins,
            testId: 'invalid_logins'
          },
          {
            title: this.$tc('day_to_expire'),
            data: info.expiration,
            testId: 'day_to_expire'
          }
        ]
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
